/* app/controls/control.listing-with-filter */

const ListingWithFilter = {
	init: function () {

		var filterOptions = document.querySelectorAll('.js-filter-option');
		// Add click event to each filter option label to submit the ancestor form
		filterOptions.forEach(option => {
			option.addEventListener('change', function () {
				const form = option.closest('form');
				if (form) {
					form.submit();
				}
			});
		});
	}
};

export { ListingWithFilter };
